module.exports = __webpack_public_path__ + "707b622696dcc282c40975536cdeccdf.svg";